/*
 * useSelectionRevealsLayers
 *
 * A persisted (non-draft) route newly entering the tree selection switches
 * the Fleet Explorer eye back on, so a fresh selection is never hidden behind
 * a muted layer. Owns this rule for every selection path (row click, fleet
 * auto-select, import). Deselecting and draft-only selections leave the eye
 * alone.
 */

import { useEffect, useRef } from "react";
import { isDraftSelectionId } from "@/features/route/state/RouteStore.jsx";

export default function useSelectionRevealsLayers({
  selectedRouteIds,
  setSwitchVesselFiltersActive,
}) {
  const prevIdsRef = useRef(new Set());

  useEffect(() => {
    const ids = selectedRouteIds ?? [];
    const prev = prevIdsRef.current;
    prevIdsRef.current = new Set(ids);
    if (ids.some((id) => !isDraftSelectionId(id) && !prev.has(id))) {
      setSwitchVesselFiltersActive(true);
    }
  }, [selectedRouteIds, setSwitchVesselFiltersActive]);
}
